import React from 'react';

const FooterWithComments = () => {
    return (
        <>
            <footer className="footer footer-wrapper">
                <div className="footer-content">
                    <section id="block-views-section-footnote" className="block block-views clearfix">


                        <div className="page-footer-item">
                            <div className="footnote-wrapper">
                                <ol>
                                    <li className="">Bears themselves are free of charge. But it is needed to pay a gas
                                        fee.
                                    </li>
                                    <li className="">The prices can be increased if the declared service becomes
                                        successful. That is why when investing your money in NFT CyberBearz Army, you
                                        should understand all risks and spend only the money you are ready to use
                                        indeed. This Is Not Financial Advice.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </section>


                    <div className="footer-copyright">
                        <div className="copyright-wrapper">
                            <div className="copyright-caption">
                                <p className="copyright-caption-title">© CyberBearz Army, 2021. All right reserved.</p>
                                <div className="copyright-caption-links">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default FooterWithComments;